import {Constructable} from '../@types/instantable';

export function isConstructor(instance: any): instance is Constructable {
	try {
		Reflect.construct(String, [], instance);

		return true;
	} catch (e) {
		return false;
	}
}
